import { render, staticRenderFns } from "./NewLogoList.vue?vue&type=template&id=12a92a60&scoped=true&"
import script from "./NewLogoList.vue?vue&type=script&lang=js&"
export * from "./NewLogoList.vue?vue&type=script&lang=js&"
import style0 from "./NewLogoList.vue?vue&type=style&index=0&id=12a92a60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a92a60",
  null
  
)

export default component.exports